<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="dialerstatus" 
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="checkEmpty p0">{{ props.item.campaign }}</td>
        <td class="checkEmpty p0">{{ props.item.availableAgents }}</td>
        <td class="checkEmpty p0">{{ props.item.dispo }}</td>
        <td class="checkEmpty p0">{{ props.item.dialer_flag }}</td>
        <td class="checkEmpty p0">{{ props.item.onCallAgents }}</td>
        <td class="checkEmpty p0">{{ props.item.totalAgents }}</td>
        <td class="checkEmpty p0">{{ props.item.dialingCalls }}</td>
        <td class="checkEmpty p0">{{ props.item.totalCalls }}</td>
        <td class="checkEmpty p0">{{ props.item.connectedCalls}}</td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
	import { mapGetters } from 'vuex';
	export default{
		data(){
			return{
				headers: [
					{ text: "Campaign", align: "left", sortable: false,class: "p0", value: "queue_name" },
					{ text: "Available Agents", align: "left", sortable: false,class: "p0", value: "total" },
          { text: "Dispo", align: "left", sortable: false,class: "p0", value: "dispo" },
          { text: "Dialer Pause", align: "left", sortable: false,class: "p0", value: "dialer_flag" },
					{ text: "OnCall Agents", align: "left", sortable: false,class: "p0", value: "pause" },
					{ text: "Total Agents", align: "left", sortable: false,class: "p0", value: "oncall" },
					{ text: "Dialing Calls", align: "left", sortable: false,class: "p0", value: "calls" },
          { text: "Total live Calls", align: "left", sortable: false,class: "p0", value: "available" },
					{ text: "Connected Calls", align: "left", sortable: false,class: "p0", value: "success" }
				],
			}
		},
		computed: {
        ...mapGetters([
            "dialerstatus"
        ]),

        queueChunk() {

            return this.queuestatus.chunk(3, this.windowWidth, 275);
        }
    },
	}
</script>
<style scoped>
	table.v-table tbody td, table.v-table thead th {
    height: 25px;
	}
</style>